<script lang="ts">
  import { T } from '@threlte/core';
  import { OrbitControls } from '@threlte/extras';
  import KettleBell from './KettleBell.svelte';
  import Block from './Block.svelte';
  import debounce from 'lodash/debounce';
  import { onDestroy, onMount } from 'svelte';

  let zoom = 375;
  let resizeObserver: ResizeObserver;

  const updateHeights = debounce(() => {
    const minDimmension = Math.min(window.innerWidth, window.innerHeight);

    if (window.innerWidth >= 1024) {
      zoom = Math.floor(120 + minDimmension / 4);
    } else {
      zoom = Math.floor(70 + minDimmension / 4);
    }
  }, 100);

  onMount(() => {
    //re-draw when the height changes
    resizeObserver = new ResizeObserver(updateHeights);
    resizeObserver.observe(document.body);
  });

  onDestroy(() => {
    resizeObserver?.unobserve(document.body);
  });
</script>

<T.OrthographicCamera makeDefault position={[-2, 2, 2]} {zoom}>
  <OrbitControls
    enableDamping
    dampingFactor={0.05}
    minPolarAngle={Math.PI * 0.25}
    maxPolarAngle={Math.PI * 0.75}
    screenSpacePanning={false}
    enablePan={false}
    enableZoom={false}
  />
</T.OrthographicCamera>

<KettleBell />
<Block />

<style lang="scss">
</style>
